import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'User Management',
    url: '/user',
    iconComponent: { name: 'cil-user' }
  },
  {
    name: 'Audit Log',
    url: '/audit-log',
    iconComponent: { name: 'cil-notes' }
  },
  {
    name: 'Firmware Upload',
    url: '/firmware',
    iconComponent: { name: 'cil-memory' }
  },
  {
    name: 'Kill Switch',
    url: '/killswitch',
    iconComponent: { name: 'cil-fork' }
  },
];
